<template>
  <div class="container mx-auto px-6 mt-12">

    <div class="flex justify-between items-center mb-4">
      <h1 class="text-4xl font-bold tracking-tight text-gray-600">Maler</h1>
    </div>

    <panel class="p-6">

      <form @submit.prevent="onSubmit" v-if="emailTemplate">

        <div>
          <label class="font-bold" for="name">Navn:</label>
          <div class="mt-2">
            <input class="w-full" id="name" subject="name" :class="{ 'invalid': errors.Name }" type="text" v-model="emailTemplate.name" required />
          </div>
        </div>

        <div class="mt-6">
          <label class="font-bold" for="subject">Emne:</label>
          <div class="mt-2">
            <input class="w-full" id="subject" name="subject" :class="{ 'invalid': errors.Subject }" type="text" v-model="emailTemplate.subject" />
          </div>
        </div>

        <div class="mt-6">
          <label class="font-bold" for="contactEmail">Melding:</label>
          <div class="mt-2">
            <textarea class="w-full h-64" id="body" name="body" v-model="emailTemplate.body"></textarea>
          </div>
        </div>

        <div class="mt-4 text-right">
          <button type="submit" class="btn btn-primary mx-2">Lagre</button>
          <router-link class="btn mx-2" to="/af/maler">Avbryt</router-link>
        </div>

      </form>

    </panel>

  </div>
</template>

<script>
import api from '@/api'
export default {
  name: 'template-create',
  props: {
    id: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      errors: [],
      emailTemplate: null
    }
  },
  methods: {
    async onSubmit () {
      const response = await api.af.updateEmailTemplate(this.emailTemplate)
      if (response.errors) {
        this.errors = response.errors
      } else {
        this.$router.push('/af/maler')
      }
    }
  },
  async created () {
    this.emailTemplate = await api.af.getEmailTemplate(this.id)
  }
}
</script>